import { Typography } from "@material-ui/core";
import React from "react";
import { StyledFooter } from "./StyledFooter";

function Footer() {
    return (
        <StyledFooter container >
            <div>
                <Typography variant="h5" className="typo">
                    Clearstream Banking AG is operating under the name Clearstream Europe AG since 26 September 2025.
                    All issuances listed here under the name Clearstream Banking AG now legally refer to Clearstream Europe AG
                </Typography>
            </div>
            <div className="footer-link">
                <a
                    href="https://www.clearstream.com/clearstream-en/privacy-policy-1277786"
                    target="_blank"
                >
                    <Typography variant="h5" className="typo">
                        Cookies Policy
                    </Typography>
                </a>
            </div>
        </StyledFooter>
    );
}
export default Footer;